var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("evaluator-assignment", {
        attrs: {
          "academic-year-id": _vm.academicYearId,
          bus: _vm.bus,
          visible: _vm.showAssigment
        },
        on: { cancel: _vm.cancelAssignmentHandler, "on-add": _vm.onAddHandler }
      }),
      _c(
        "div",
        { staticClass: "score-display-row" },
        [
          _vm.data.hasPenalty
            ? _c("section-title", {
                staticClass: "score-display-row__penalty-display",
                attrs: {
                  "container-class":
                    "score-display-row__penalty-display__container",
                  icon: "fas fa-exclamation",
                  title: "La puntuación final tiene penalidades consideradas.",
                  "title-class": "score-display-row__penalty-display__info"
                }
              })
            : _vm._e(),
          _c("custom-percentage", {
            staticClass: "custom-percent",
            attrs: { percentage: _vm.generalScore, title: "Puntuación Final" }
          })
        ],
        1
      ),
      _c("section-title", {
        staticClass: "mb-4",
        attrs: { "has-line": true, title: "Información de Evaluadores" }
      }),
      _vm.data.evaluations == undefined || _vm.data.evaluations.length === 0
        ? _c("custom-result-not-found", {
            attrs: { text: "No hay información disponible" }
          })
        : _vm._e(),
      _vm._l(_vm.evaluationsGroup, function(value, name) {
        return _c(
          "div",
          { key: name },
          [
            _vm.showTitles
              ? _c("section-title", {
                  staticClass: "my-4",
                  attrs: {
                    "has-line": false,
                    icon: "far fa-file-alt",
                    reverse: true,
                    title: name
                  }
                })
              : _vm._e(),
            _vm._l(value, function(evaluator, index) {
              return _c("evalator-row-score", {
                key: `rows-list-selected-${index}`,
                staticClass: "mb-3",
                attrs: {
                  evaluator: evaluator,
                  index: index,
                  "rubric-id": _vm.rubricId
                },
                on: {
                  "on-remove": function($event) {
                    return _vm.onRemoveHandler(evaluator, index)
                  }
                }
              })
            }),
            _vm.showTitles
              ? _c(
                  "div",
                  { staticClass: "d-flex justify-content-end my-md-4" },
                  [
                    _c("custom-percentage", {
                      staticClass:
                        "custom-percent custom-percent--group bg-secondary-3 p-md-2",
                      attrs: {
                        percentage: _vm.evaluationsGroupScores[name].toString(),
                        title: "Puntuación Promedio"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          2
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }